module.exports = __webpack_public_path__ + "static/media/CheckIcon.62ffb8b5.svg";